import React, { useState } from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import * as branchActions from '../../redux/branches'
import * as orgActions from '../../redux/organisations'
import DynamicForm from '../DynamicForm/DynamicForm'
import { Flex, Box } from 'reflexbox'
import set from 'set-value'
import { HealtheraButton, HeaderContainer, HeaderTitle, BounceAnimatedContainer, PaperContainer, SubHeader } from '../../healtheraComponents'
import { validated } from '../../helpers'
import { Schema } from './InputSchema'

type StateProps = {
    organisations: {
        organisation: any;
    };
};

type GeocodeWarning = string | null;

type AjaxThunkResponse = {
    error?: {
        response?: {
            data?: { error?: string };
        };
    };
};

const CreateNewBranch: React.FC<RouteComponentProps> = ({ history }) => {
    const dispatch = useDispatch()
    const orgID = history.location.pathname.match(/[\d\w-]*$/gi)![0]
    const { organisation } = useSelector((state: StateProps) => state.organisations);
    const [branch, setBranch] = useState({
        timezone: 'Europe/London',
        address: { country: 'England' },
        propelIntegrationEnabled: false
    });
    // Telephone isn't mandatory
    const [validations] = useState({
        pharmacy_name: false,
        timezone: true,
        primaryContact:
            {
                email: false,
                firstName: true,
                lastName: true
            }
    })

    const [disabled, setDisabled] = useState(true)

    React.useEffect(() => {
        // Get Organisation
        dispatch(orgActions.getOrganisation(orgID))
    }, [dispatch, orgID])

    const onChange = ({ field, value, validation }) => {
        if (validation !== undefined)
            set(validations, field, validation)
        set(branch, field, value)

        if (field === 'propelIntegrationEnabled') {
            if (!value) {
                delete validations['externalPharmacyId']
            } else {
                set(validations, 'externalPharmacyId', false);
            }
        }

        setBranch({ ...branch })
        setDisabled(!validated(validations))
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        const newBranch = { ...branch, status: 'inactive', chain_id: orgID }
        const geoWarning = await dispatch(branchActions.resolveBranchCoordinates(newBranch)) as unknown as GeocodeWarning
        if (geoWarning) alert(geoWarning)
        const response = await dispatch(branchActions.createNewBranch(newBranch)) as unknown as AjaxThunkResponse
        if (response.error)
            alert(response.error.response?.data?.error || 'An error occurred')
        else history.push(`${process.env.PUBLIC_URL}/organisations/${orgID}`)
    }

    return (
        <>
            {organisation && <BounceAnimatedContainer>
              <HeaderContainer padding={`20px 0 20px 0`} borderbottom="none" p={2} align='center'>
                <HeaderTitle cursor={`pointer`} width="33%"> Create a new pharmacy under {organisation.name} </HeaderTitle>
              </HeaderContainer>
              <PaperContainer elevation={0}>
                <Flex>
                  <Box>
                    <SubHeader title='Pharmacy Details' />
                    <DynamicForm onChange={onChange} fields={Schema(branch).pharmacyDetails} />
                  </Box>
                  <Box>
                    <SubHeader title='Pharmacy Contact' />
                    <DynamicForm onChange={onChange} fields={Schema(branch).pharmacyContact} />
                  </Box>
                </Flex>
                <HealtheraButton disabled={disabled} onClick={onSubmit}>Create</HealtheraButton>
                <br />
              </PaperContainer>
            </BounceAnimatedContainer>}
        </>
    )
}

export default withRouter(CreateNewBranch)
